import { render, staticRenderFns } from "./user-gallery.vue?vue&type=template&id=74279ae0&"
import script from "./user-gallery.vue?vue&type=script&lang=js&"
export * from "./user-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports